<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>
  <!-- FORM -->

  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.RUM_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="rumTypes | toSelectOption: 'PRODUCTS.RUM_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <div class="in-two-columns">
    <!-- agingTime number & unit select -->

    <mat-form-field>
      <app-easy-input
        formControlName="agingTime"
        [label]="TITLE + 'AGING_TIME' | translate"
        type="number"
        min="1"
        (ngModelChange)="
          $event
            ? getCtrl('agingTimeUnit')?.setValidators(Validators.required)
            : getCtrl('agingTimeUnit')?.clearValidators()
        "
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="agingTimeUnit"
        [label]="TITLE + 'AGING_TIME_UNIT' | translate"
        [translatePrefixForSelected]="'PRODUCTS.AGING_TIME_UNIT.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="agingTimeUnits | toSelectOption: 'PRODUCTS.AGING_TIME_UNIT.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <mat-form-field>
    <app-easy-checkbox
      formControlName="volatileSubstanceAtLeast225gphl"
      [label]="TITLE + 'VOLATILE_SUBSTANCE_AT_LEAST_225_GPHL' | translate"
      (ngModelChange)="volatileChanged($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="calculatedPureAlcoholExceeding7_9EURperLiter"
        [label]="
          TITLE + 'CALCULATED_PURE_ALCOHOL_EXCEEDING_7_9_EUR_PER_LITER'
            | translate
        "
        [translatePrefixForSelected]="'PRODUCTS.RUM_PROPERTIES.SELECT_OPTIONS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="
          selectBoolean
            | toSelectOption: 'PRODUCTS.RUM_PROPERTIES.SELECT_OPTIONS.'
        "
        [errorStateMatcher]="notEmptyFieldsStateMatcher"
        (ngModelChange)="
          originalValue79Eur !== $event ? pureAlcoholChanged79Eur() : ''
        "
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="calculatedPureAlcoholExceeding2EURperLiter"
        [label]="
          TITLE + 'CALCULATED_PURE_ALCOHOL_EXCEEDING_2_EUR_PER_LITER'
            | translate
        "
        [translatePrefixForSelected]="'PRODUCTS.RUM_PROPERTIES.SELECT_OPTIONS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="
          selectBoolean
            | toSelectOption: 'PRODUCTS.RUM_PROPERTIES.SELECT_OPTIONS.'
        "
        [errorStateMatcher]="notEmptyFieldsStateMatcher"
        (ngModelChange)="
          originalValue2Eur !== $event ? pureAlcoholChanged2Eur() : ''
        "
      >
      </app-easy-select>
    </mat-form-field>
  </div>
</fieldset>
